{
  "schemaVersion": 1,
  "kind": "mallard-physical-float-study-profile",
  "assetSHA256": "ce5988b4338b821e2b913b2ddad5a84c2f0cd4d7499c3c01af4be5cc636078ff",
  "authoredSequenceSHA256": "f3055cc9bacc3c430609e31321ffbbb1726b44f2a2c433fe53816427a4189e2d",
  "sourceMotionAuditSHA256": "2dcebb1c19104d05dd54aca97a08d73a449fe202b50c9a7309aa4e5f652acbd4",
  "units": "metres",
  "up": "+Y",
  "forward": "-Z",
  "identity": {
    "common": "Mallard, adult drake breeding plumage",
    "scientific": "Anas platyrhynchos",
    "scope": "Photo-guided modeled phenotype, not a scan or measured individual"
  },
  "neutralAllGeometryBounds": {
    "min": [
      -0.09521560370922089,
      0.0024720457591220174,
      -0.21079036058981906
    ],
    "max": [
      0.09522151947021484,
      0.3298454149641913,
      0.2749999833684522
    ]
  },
  "coreBounds": {
    "min": [
      -0.09521560370922089,
      0.07272464686960808,
      -0.21079036058981906
    ],
    "max": [
      0.09522151947021484,
      0.3298454149641913,
      0.24987877455674964
    ]
  },
  "authoredSweptBounds": {
    "bank-two-step-settle": {
      "min": [
        -0.09921560436487198,
        -2.3981556296348572e-08,
        -0.41097182035446167
      ],
      "max": [
        0.09922152012586594,
        0.3273734450340271,
        0.2750000059604645
      ]
    },
    "floating-paddle-idle": {
      "min": [
        -0.09521560370922089,
        -0.06158331781625748,
        -0.41479045152664185
      ],
      "max": [
        0.09522151947021484,
        0.3298454284667969,
        0.2750000059604645
      ]
    }
  },
  "float": {
    "waterlineYMetres": 0.13,
    "rootPlacement": "rootY = actual surface water height minus 0.130 * worldUnitsPerMetre * seededUniformVariation; keep bank grounding a separate domain.",
    "neutralBodyPitchRadians": 0,
    "neutralBodyRollRadians": 0,
    "orientationScope": "Neutral authored pose only. Any surface-normal tilt/heave requires its own swept skin/environment checks.",
    "sections": [
      {
        "waterlineYMetres": 0.12,
        "hullDraftMetres": 0.04727535313039191,
        "intersectionSegments": 325,
        "closedDegreeTwoSection": true,
        "loops": [
          {
            "vertices": 325,
            "planarAreaSquareMetres": 0.03710235682377899,
            "bounds": {
              "min": [
                -0.0871050418530276,
                0.12,
                -0.07520753717697715
              ],
              "max": [
                0.08709617048686182,
                0.12,
                0.19287847830071825
              ]
            }
          }
        ],
        "sectionBounds": {
          "min": [
            -0.0871050418530276,
            0.12,
            -0.07520753717697715
          ],
          "max": [
            0.08709617048686182,
            0.12,
            0.19287847830071825
          ]
        },
        "submergedCoreVertices": 2329,
        "coreVertexCount": 14792
      },
      {
        "waterlineYMetres": 0.13,
        "hullDraftMetres": 0.05727535313039192,
        "intersectionSegments": 336,
        "closedDegreeTwoSection": true,
        "loops": [
          {
            "vertices": 336,
            "planarAreaSquareMetres": 0.041986875257239806,
            "bounds": {
              "min": [
                -0.09154471662585088,
                0.13,
                -0.0841968057334565
              ],
              "max": [
                0.09154568686418,
                0.13,
                0.2034262567820558
              ]
            }
          }
        ],
        "sectionBounds": {
          "min": [
            -0.09154471662585088,
            0.13,
            -0.0841968057334565
          ],
          "max": [
            0.09154568686418,
            0.13,
            0.2034262567820558
          ]
        },
        "submergedCoreVertices": 2889,
        "coreVertexCount": 14792
      },
      {
        "waterlineYMetres": 0.14,
        "hullDraftMetres": 0.06727535313039193,
        "intersectionSegments": 348,
        "closedDegreeTwoSection": true,
        "loops": [
          {
            "vertices": 348,
            "planarAreaSquareMetres": 0.04578175203158892,
            "bounds": {
              "min": [
                -0.09421163236652982,
                0.14,
                -0.09128460535359716
              ],
              "max": [
                0.09420173998418162,
                0.14,
                0.21428407449148285
              ]
            }
          }
        ],
        "sectionBounds": {
          "min": [
            -0.09421163236652982,
            0.14,
            -0.09128460535359716
          ],
          "max": [
            0.09420173998418162,
            0.14,
            0.21428407449148285
          ]
        },
        "submergedCoreVertices": 3430,
        "coreVertexCount": 14792
      }
    ],
    "sectionScope": "Actual rest exported Mallard_core geometry intersected by a horizontal plane. A closed section is a geometric check only; no mass, water displacement, pressure or restoring torque solved.",
    "actualAuthoredWebExtrema": {
      "L": {
        "minWebYMetres": -0.05841810256242752,
        "maxWebYMetres": 0.15031376481056213,
        "minSubmergedVertexFraction": 0.9001168224299065,
        "maxSubmergedVertexFraction": 1.0
      },
      "R": {
        "minWebYMetres": -0.05844093859195709,
        "maxWebYMetres": 0.15031598508358002,
        "minSubmergedVertexFraction": 0.8971662284545721,
        "maxSubmergedVertexFraction": 1.0
      }
    },
    "maximumAllGeometryDepthBelowWaterlineMetres": 0.19158331781625748
  },
  "reference": {
    "path": "references/lavalle-floating.jpg",
    "sha256": "16e8dcda59343d1eab24708d77a93dcdcd20b147a855345a2f57bda7db587d7a",
    "url": "https://www.fws.gov/media/mallard-floating-water-billy-frank-jr-nisqually-national-wildlife-refuge",
    "credit": "LaValle / USFWS, public-domain source photograph",
    "scope": "Actually inspected oblique floating adult drake. Supports flank/chest immersion and concealed proximal legs qualitatively. Perspective, reflected surface and unknown submerged hull prevent calibrated draft/roll measurement."
  },
  "limits": [
    "Waterline0.130m and zero pitch/roll remain illustrative engineering alignment, pending actual habitat comparison.",
    "No buoyancy, load, mass, propulsion or finite support-patch validation.",
    "Bank and water actions remain separate; no shore transition or flight.",
    "Source motion ranges are authored diagnostics, not biological cadence.",
    "Proxy needs its own sections, bounds and actual contact scan."
  ]
}
